var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { instanceToPlain, plainToInstance } from 'class-transformer';
import queries from 'constants/queries';
import { Document, PaginationMetaData } from 'models';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import ApiService from '../ApiService';
import { useNavigate } from 'react-router';
var DocumentService = /** @class */ (function (_super) {
    __extends(DocumentService, _super);
    function DocumentService() {
        var _this = _super.call(this) || this;
        _this.documentsRoot = 'documents';
        _this.successMessage = '';
        return _this;
    }
    DocumentService.prototype.useDocuments = function (pageNumber, filters) {
        var _this = this;
        if (pageNumber === void 0) { pageNumber = 1; }
        if (filters === void 0) { filters = {}; }
        return useQuery([queries.accounting.documents, pageNumber, filters], function () {
            return _this.get(_this.documentsRoot, __assign(__assign({}, filters), { page: pageNumber }));
        }, {
            keepPreviousData: true,
            select: function (_a) {
                var data = _a.data;
                var documents = plainToInstance(Document, data === null || data === void 0 ? void 0 : data.documents);
                var meta = plainToInstance(PaginationMetaData, data === null || data === void 0 ? void 0 : data.meta);
                return { documents: documents, meta: meta };
            }
        });
    };
    DocumentService.prototype.useGetDocument = function (id) {
        var _this = this;
        return useQuery(['show-', queries.accounting.documents, id], function () {
            return _this.get("".concat(_this.documentsRoot, "/").concat(id));
        }, {
            retry: false,
            select: function (_a) {
                var data = _a.data;
                return plainToInstance(Document, data);
            }
        });
    };
    DocumentService.prototype.useCreateDocument = function () {
        var _this = this;
        var queryClient = useQueryClient();
        var navigate = useNavigate();
        return useMutation(function (_a) {
            var document = _a.document, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            var data = { document: instanceToPlain(document) };
            return _this.post(_this.documentsRoot, { data: data });
        }, {
            retry: false,
            onSuccess: function () {
                queryClient.invalidateQueries(queries.accounting.documents);
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
                navigate('/documents');
            }
        });
    };
    DocumentService.getInstance = function () {
        if (!DocumentService.documentService) {
            DocumentService.documentService = new DocumentService();
        }
        return DocumentService.documentService;
    };
    return DocumentService;
}(ApiService));
export default DocumentService;
